import React from 'react'

import { localizer, languages, changeLanguage } from '../../Translator'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { Switch, FormControlLabel} from "@material-ui/core";

import Roles from "../Utilities/Roles"
import { SnackbarCustom } from "../Utilities/SnackbarCustom"

import { AutocompleteStyled } from "../common/InputStyled"
import { TextAreaStyled } from "../common/InputStyled"
import { TextFieldStyled } from "../common/InputStyled"
import BackdropStyled from '../common/BackdropStyled'
import ScreenHeading from '../common/ScreenHeading.js'

import AuthCli from '../../sdk/AuthCli'


/**
 * Tool for the system administrator to send new invitations to future users.
 * These users can be invited to any realm (not only billables) with any role.
 */
export class SendInvitationsScreen extends React.Component {

  constructor(props) {
    super(props)
    this.state = {

      // List of e-mail addresses to be invited as typed by the user.
      // This content is allowed to separate e-mails inside by spaces,
      // new-line characters, commas and semi-colons.
      // Note: this is not an array because controlled by the textarea UI control.
      emails: '',

      // Name of the realm currently selected by the user to be the one granted 
      // to the invited users.
      realm: '',

      // Identifier of the role to be granted to the invited users.
      roles: [],
      role: null,

      // ISO code of the language to be the desired one of the invited users.
      // The invitation message (e-mail message) will be sent in this language.
      culture: languages[0],

      // All realms available in the system, for the user to select one.
      availableRealms: [],

      //mfa required
      mfaRequired: null,

      // Used to show the spinner when waiting for server response.
      loading: false,

      // Opens the confirmation dialog where the user confirms the invitations
      // to be generated.
      openConfirmationDialog: false,

      // Opens the dialog where the results received from the server appear.
      openRequestResultsDialog: false,

      // While sending invitation request to server for each typed e-mail
      // this array keeps the error messages for each.
      requestResultMessages: [],
      messageSnackbar: null,
      severity: "info",

      // To contain those e-mail addresses attempted to invite but failed for some reason.
      // They are kept here as they fail in order to preserve them in the list instead of
      // leaving this screen.
      failedEmails: []
    }

    // Force focus on email list.
    this.focusOnEmails = true
  }

  async componentDidMount() {
    AuthCli.GetSessionInfo().then(session => {
      if (session) {
        if (session.role !== Roles.ROLE_ADMIN.Name) {
          window.location.href = "shipment"
          return
        }
      }
    })
    
    await this.setUserLanguage()
    // Loading from server all available realms in the realm selector.
    this.loadBillableRealm()
    this.getRoles()
  }

  /**
   * Establishes the language of the application based on the last used culture.
   * This action is required when the user directly navigates editing the browser's address line
   * instead of navigating using application's links.
   */
  async setUserLanguage() {
    var newLanguage = window.localStorage.getItem("culture")
    if (newLanguage === localizer.getLanguage()) {
      let cultureSelected = languages.find(culture => culture.code === newLanguage)
      this.setState({ culture: cultureSelected })
      
      return
    }
    await changeLanguage(newLanguage)
    this.handleLanguageChange(newLanguage)
  }

  /**
   * To be called by components that may change the current application language.
   * Forcing the whole application to re-render.
   */
  handleLanguageChange(newLanguage) {
    let cultureSelected = languages.find(culture => culture.code === newLanguage)
    this.setState({ culture: cultureSelected })
  }

  /**
   * Requests to the auth service the list of all available realms
   * currently in the system. Stored in state for the realm selection to be filled in.
   */
  loadBillableRealm = () => {
    AuthCli.GetSessionInfo().then(session => {
      this.setState({ realm: session.realm })
    })
  }

  /**
   * roles to fill the autocomplete 
   * It is not set as a global variable because if not it does not take the location to translate
   */
  getRoles = () => {
    let roles = [
      { "id": Roles.ROLE_USER.Name, "name": Roles.ROLE_USER.Name + ' - ' + localizer.InviteRoleDescriptionUser },
      { "id": Roles.ROLE_SUPERVISOR.Name, "name": Roles.ROLE_SUPERVISOR.Name + ' - ' + localizer.InviteRoleDescriptionSupervisor },
      { "id": Roles.ROLE_ADMIN.Name, "name": Roles.ROLE_ADMIN.Name + ' - ' + localizer.InviteRoleDescriptionAdmin },]
    this.setState({ roles: roles, role: roles[0] })
  }

  /**
   * Provides the array of emails typed by the user currently in the
   * multi-line box. It is assumed each e-mail is separated by spaces,
   * new-line characters, comma or semi-colon characters.
   */
  fromRawEmailsToArray = () => {
    return this.state.emails
      .replace(/\r?\n/g, ' ')
      .replace(';', ' ')
      .replace(',', ' ')
      .split(' ').filter(e => e.trim().length > 0)
  }

  /**
   * Controlled fields refresh.
   */
  handleFieldChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }



  /**
   * The user has pressed the button to proceed sending invitations.
   * Asking for confirmation before proceed.
   */
  handleSendInvitations = () => {
    this.setState({ openConfirmationDialog: true })
  }

  /**
   * Proceeds requesting invitations to server for those
   * e-mails currently typed by the user and currently selected options.
   */
  doSendInvitations = () => {
    this.setState({ loading: true })
    // Each e-mail typed is taken and an independent invitation request is sent for each.
    this.fromRawEmailsToArray().map(email => {
      return (
        AuthCli.Invite({
          userEmail: email,
          realm: this.state.realm,
          role: this.state.role.id,
          culture: this.state.culture.code,
          mfaRequired: this.state.mfaRequired
        }).then((error) => {
          this.setState({ loading: false })

          let severity = "success"
          
          // Add the result for this particular e-mail to the dialog.
          if (error && error.startsWith("[ERR")) {
            error = error.substring(error.indexOf(' '))
            severity = "error"
          }
          this.setState(preState => ({ requestResultMessages: [...preState.requestResultMessages, (error ? localizer.InviteFail + ": " : localizer.InviteDone + ": ") + email + (error ? " : " + error : "")] }))

          let message = (error ? localizer.InviteFail + ": " : localizer.InviteDone + ": ") + email + (error ? " : " + error : "") + " \n"
          let messageSnackbar = this.state.messageSnackbar === null ? message : this.state.messageSnackbar + message
          this.setState({ messageSnackbar: messageSnackbar, severity: severity })

          // In case this e-mail address has failed for invitation, keep it in the list
          // filled in by the user once the results dialog is closed.
          if (error) this.setState(preState => ({ failedEmails: [...preState.failedEmails, email] }))
        })
      )
    })
  }

  /**
   * The user has canceled the invitations in progress.
   */
  handleConfirmationDialogCancel = () => {
    this.setState({ openConfirmationDialog: false })
  }

  /**
   * The user has confirmed to send the invitations.
   */
  handleConfirmationDialogConfirm = () => {
    this.doSendInvitations()
    this.setState({
      openConfirmationDialog: false,
      openRequestResultsDialog: true // Open up results dialog for the results to appear as they arrive.
    })
  }

  /**
   * The user has just finished sending invitations by closing the results dialog.
   * Failed e-mails are kept in the list.
   */
  handleRequestResultsDialogClose = () => {
    this.setState(preState => ({
      openRequestResultsDialog: false,
      emails: preState.failedEmails.join('\n'),
      failedEmails: [],
      realm: '',
      requestResultMessages: []
    }))
  }


  /**
  * When user change the role, role selected from state must be refresh.  
  */
  handleRoleSelect = (event, option) => {
    if (option !== null) {
      let roleSelected = this.state.roles.find(role => role.id === option.id)
      this.setState({ role: roleSelected })
    }
  }
  
  /**
  * When user change the role, role selected from state must be refresh.  
  */
  handleCultureSelect = (event, option) => {
    if (option !== null) {
      let cultureSelected = languages.find(culture => culture.code === option.code)
      this.setState({ culture: cultureSelected })
    }
  }

  /**
  * When user change the role, role selected from state must be refresh.  
  */
  handleMfaSelect = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    let mfaRequired = value ? AuthCli.MFA_OPTION_EMAIL : null
    this.setState({ mfaRequired: mfaRequired })
  
  }
  

  handleonClose = () => {
    this.setState({ messageSnackbar: null })
  }
  render() {

    // Calculate whether the main button to proceed sending invitations must be enabled.
    const readyToSave = this.state.emails !== "" && this.state.realm !== "" && this.state.role !== "" && !this.state.loading

    return (
      <React.Fragment>
        <Container>
          {/* <GridHeaderComponent container direction="row" spacing={4}>
            <Grid item md={12}>
              <Typography className="typography-generic header-title"><i className="fa-solid fa-user-plus"></i>  {localizer.Invite}</Typography>
            </Grid>
          </GridHeaderComponent> */}
         
          {/* Screen heading. */}
          <ScreenHeading className="typography-generic" icon={<i className="fa-solid fa-user-plus icon-button-header mr-20 ml-20"></i>} title={localizer.Invite} />
         
          {/* TODO: temporary links to go back to list of invitations */}
          
          <Grid container direction="row" justify="center" alignItems="center" spacing={4} className="container-generic mt-20">
            <Typography className="typography-generic">{localizer.InvitationsDescription}</Typography>
            
            <Grid item xs={6}>
              <Typography className='typography-generic' variant="h5" display="block" gutterBottom >
                <strong>{"1. " + localizer.InviteTypeEmails}</strong>
              </Typography>
              <TextAreaStyled style={{ lineHeight: "150%" }}
                variant="outlined"
                fullWidth
                multiline
                rows={10}
                placeholder={localizer.InviteTypeEmailsPlaceholder}
                InputProps={{
                  classes: {
                    input: "typography-generic"
                  },
                  inputProps: {
                    maxLength: 1000, style: { lineHeight: '1.5' }
                  }
                }}
                name="emails"
                value={this.state.emails}
                onChange={this.handleFieldChange}
                inputRef={(input) => { if (input != null && this.focusOnEmails) { input.focus(); this.focusOnEmails = false } }}
              />
            </Grid>
            <Grid container item xs={6}>
              <Grid item xs={12}>
                <Typography className='typography-generic' variant="h5" display="block" gutterBottom >
                  <strong>{"2. " + localizer.InviteSelectGroup}</strong>
                </Typography>
                <Typography className='typography-generic' variant="h5" display="block" gutterBottom >
                  {localizer.InvitedWorkingGroup + ": " + this.state.realm}
                </Typography>
                {/* Realm selection 
                <AutocompleteStyled
                  classes={{ input: 'typography-generic', option: 'typography-generic' }}
                  id="realm"
                  options={[this.state.realm]}
                  name="realm"
                  disableClearable={true}
                  renderInput={(params) => <TextFieldStyled {...params} autoComplete="off" variant="outlined" />}
                  onChange={(event, newValue) => {
                    this.setState({ realm: newValue })
                  }}
                  value={this.state.realm}
                  fullWidth
                />*/}
                {/* Role selection */}
                <AutocompleteStyled
                  classes={{ input: 'typography-generic', option: 'typography-generic' }}
                  id="role"
                  name="role"
                  options={this.state.roles}
                  fullWidth
                  getOptionLabel={(option) => (option.name ? option.name : '')}
                  getOptionSelected={(option, value) => option.value === value.value}
                  disableClearable={true}
                  renderInput={(params) => <TextFieldStyled {...params} autoComplete="off" variant="outlined" />}
                  onChange={this.handleRoleSelect}
                  value={this.state.role}
                />
                <br />
              </Grid>

              <Grid item xs={12}>
                <Typography className='typography-generic' variant="h5" display="block" gutterBottom >
                  <strong>{"3. " + localizer.InviteSelectLanguage}</strong>
                </Typography>

                {/* Language selection */}
                <AutocompleteStyled
                  classes={{ input: 'typography-generic', option: 'typography-generic' }}
                  id="culture"
                  name="culture"
                  options={languages}
                  getOptionLabel={(option) => (option.name ? option.name : '')}
                  getOptionSelected={(option, value) => option.value === value.value}
                  disableClearable={true}
                  renderInput={(params) => <TextFieldStyled {...params} autoComplete="off" variant="outlined" />}
                  onChange={this.handleCultureSelect}
                  value={this.state.culture}
                />
              </Grid>
              <Grid container item xs={12}>
                <Grid item xs={9}>
                  <Typography className='typography-generic mt-20' variant="h5" display="block" gutterBottom >
                    <strong>{"4. " + localizer.InviteSelectMfa}</strong>
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <FormControlLabel className="typography-generic mt-10"
                    control={<Switch name={"mfaRequired"} color="primary" checked={this.state.mfaRequired} onChange={this.handleMfaSelect} inputProps={{ 'aria-label': 'secondary checkbox' }} />}
                  />
                </Grid>
              </Grid>
              {/* Save changes button. */}
              <Grid item xs={12} className="text-align-right">
                <Button className="button-generic" variant="contained" color="secondary" disabled={!readyToSave} onClick={this.handleSendInvitations}>
                  {localizer.InviteSendInvitations}
                </Button>
              </Grid>
            </Grid>
          </Grid>
         

          {/* Waiting for service response */}
          {this.state.loading &&
            <BackdropStyled open={this.state.loading}>
              <CircularProgress color="secondary" />
            </BackdropStyled>
          }

          {/* Send invitations confirmation dialog */}
          <Dialog
            open={this.state.openConfirmationDialog}
            onClose={this.handleConfirmationDialogCancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="md"
          >
            <DialogTitle>
              <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={this.handleConfirmationDialogCancel}></i>
              <Typography className="typography-generic dialog-title">{localizer.InviteConfirmSend}</Typography>
            </DialogTitle>
            <DialogContent dividers={true} className="dialog-content">
              <Grid container direction="row" spacing={4} className="mt-10">
                <Grid container item md={12} direction="row" spacing={2}>
                  <Typography className="typography-generic">{localizer.formatString(localizer.InviteAboutToSend, this.fromRawEmailsToArray().length)}<br /></Typography>
                </Grid>
                
                <Grid container item md={12} direction="row" spacing={2} justify="flex-end" className="mt-10">
                  <Button className="button-generic dialog-cancel" variant="outlined" onClick={this.handleConfirmationDialogCancel}>
                    {localizer.InviteCancel}
                  </Button>
                  <Button className="button-generic dialog-primary" variant="contained" onClick={this.handleConfirmationDialogConfirm} >
                    {localizer.InviteProceed}
                  </Button>

                </Grid>
              </Grid>

            </DialogContent>
          </Dialog>

        </Container>

        {/* Invitation requests results*/}
        <SnackbarCustom message={this.state.messageSnackbar} severity={this.state.severity} handleonClose={this.handleonClose} />
        
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/invite/SendInvitationsScreen.js